// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import {Line} from './line.js'
import {NormalShape} from './normal-shape.js'
import {Polygon} from './polygon.js'

export enum ShapeDefinitionType {
  NONE = 0,
  Line = 1,
  Polygon = 2,
  NormalShape = 3
}

export function unionToShapeDefinitionType(
  type: ShapeDefinitionType,
  accessor: (obj: Line | NormalShape | Polygon) => Line | NormalShape | Polygon | null
): Line | NormalShape | Polygon | null {
  switch (ShapeDefinitionType[type]) {
    case 'NONE':
      return null
    case 'Line':
      return accessor(new Line())! as Line
    case 'Polygon':
      return accessor(new Polygon())! as Polygon
    case 'NormalShape':
      return accessor(new NormalShape())! as NormalShape
    default:
      return null
  }
}

export function unionListToShapeDefinitionType(
  type: ShapeDefinitionType,
  accessor: (index: number, obj: Line | NormalShape | Polygon) => Line | NormalShape | Polygon | null,
  index: number
): Line | NormalShape | Polygon | null {
  switch (ShapeDefinitionType[type]) {
    case 'NONE':
      return null
    case 'Line':
      return accessor(index, new Line())! as Line
    case 'Polygon':
      return accessor(index, new Polygon())! as Polygon
    case 'NormalShape':
      return accessor(index, new NormalShape())! as NormalShape
    default:
      return null
  }
}
